import { Injectable } from '@angular/core';
import { CounterWidgetDataEntryDto } from '@osos/shared/api';
import { CounterWidgetDataEntryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { CounterEntryParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class CounterFactoryService extends FactoryBase<
  CounterWidgetDataEntryDto,
  CounterWidgetDataEntryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: CounterEntryParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: CounterWidgetDataEntryPresenterModel,
  ): CounterWidgetDataEntryDto {
    const parser = this.getParser(
      CounterWidgetDataEntryDto,
      CounterWidgetDataEntryPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: CounterWidgetDataEntryDto,
  ): CounterWidgetDataEntryPresenterModel {
    const parser = this.getParser(
      CounterWidgetDataEntryDto,
      CounterWidgetDataEntryPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
